import { render } from "./Lds.vue?vue&type=template&id=8b485592"
import script from "./Lds.vue?vue&type=script&lang=js"
export * from "./Lds.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__